import { useQueryParams } from '@elentari/core'
import { useEffect } from 'react'
import snackbarStore from '../../stores/snackbar'
import { getAuthorizations } from '../../utils/crudAuthorization'
import { useAbility } from '../login'
import { cenariosRepository } from './hooks/cenariosRepository'
import { cenariosStore } from './stores/cenarios'
import { CenariosFilter, CenariosQueryFilter } from './CenariosFilter'
import { CenariosTable } from './CenariosTable'

const CenariosList = () => {
  const { initialValues } = useQueryParams<CenariosQueryFilter>()
  const ability = useAbility()

  async function handleDelete(id: string) {
    const response = await cenariosRepository.delete(id)

    if (response.ok) {
      snackbarStore.setMessage('Cenário excluído com sucesso')
      cenariosStore.cenarios.setFilters(initialValues)
      return
    }

    const message = (response.data as unknown as any)?.message
    snackbarStore.setMessage(message || 'Não foi possível excluir o cenário')
  }

  const authorization = getAuthorizations(ability, 'Cenários')

  useEffect(() => {
    cenariosStore.cenarios.setPage(Number(initialValues.page) || 1)
    cenariosStore.cenarios.setFilters(initialValues)
  }, [initialValues]) // eslint-disable-line

  return (
    <>
      <CenariosFilter />
      <CenariosTable authorization={authorization} onDelete={handleDelete} />
    </>
  )
}

export default CenariosList
